import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { PageFrame, ScrollToTop } from "./components/SiteChrome";
import AboutPage from "./pages/AboutPage";
import CvPage from "./pages/CvPage";
import HomePage from "./pages/HomePage";
import ProjectPage from "./pages/ProjectPage";
import WorkPage from "./pages/WorkPage";
import "./App.scss";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageFrame>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Redirect path="/signal" exact to="/" />
          <Route path="/work" exact component={WorkPage} />
          <Route path="/work/:slug" component={ProjectPage} />
          <Route path="/about" component={AboutPage} />
          <Route path="/cv" exact component={CvPage} />
          <Route component={HomePage} />
        </Switch>
      </PageFrame>
    </BrowserRouter>
  );
}

export default App;
